import React, { useState } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import { useLocation, useParams, useHistory } from 'react-router-dom';

import { globals as globalsSlice } from '../../../../app/globalsSlice';
import PageTitleBreadcrumb from '../../../../components/PageTitleBreadcrumb';
import { t } from '../../../../providers';
import { me as meSlice } from '../../../AuthenticatedPage/authenticationSlice';
import FieldsMissingDialog from '../../../MyAccountPage/components/ChildAccounts/FieldsMissingDialog';
import servicesItems from '../../servicesItems';
import ServicesList from '../ServicesList/ServicesList';
import { getLocale } from '../../../../providers';
import PageTitle from '../../../../components/PageTitle';

const useStyles = makeStyles(() => ({
    tabs: {
        '& .MuiTabs-scroller::-webkit-scrollbar-thumb': {
            backgroundColor: 'unset',
        },
        '& .MuiTab-root': {
            minWidth: '100px',
        },
    },
    tabContainer: {
        width: '100%',
    },
    profileTabContainer: {
        '@media (min-width:1100px)': {
            // width: '653px',
        },
    },
    onlineServiceTitle: {
        marginTop: '-32px',
    },
}));

const ReplyProvisionalRefusalPage = () => {
    const classes = useStyles();
    const { service, category } = useParams();
    const location = useLocation();
    const history = useHistory();
    const me = useSelector(meSlice);
    const { globals } = useSelector(globalsSlice) || {};

    const [tabs, setTabs] = useState([]);
    const [selectedTab, setSelectedTab] = useState(0); //index of tabs
    const [dialogOpen, setDialogOpen] = useState(false);
    const selectedLanguage = getLocale();

    const navigateTo = (event, path, external) => {
        event.preventDefault();
        if (path && external) {
            let newPath = path;

            if (!!newPath && !newPath.startsWith('http')) newPath = globals.ipo['fo.url'].concat(globals.ipo[path]);
            if (newPath.indexOf('?') >= 0) {
                newPath += `&lang=${selectedLanguage}`;
            } else {
                newPath += `?lang=${selectedLanguage}`;
            }
            if (!!newPath) window.open(newPath, '_blank');
        } else {
            if (path && location.pathname !== path) {
                history.push(path);
            }
        }
    };

    const navigateToProfile = (event) => {
        event.preventDefault();
        setDialogOpen(false);
        history.push('/my-account/profile-details');
    };

    const cancelMessage = (event) => {
        event.preventDefault();
        setDialogOpen(false);
    };

    // filter e-services items based on tab selection
    let availableItems = servicesItems[service]['replyProvisionalRefusal'];
    if (selectedTab !== 0) {
        availableItems = availableItems.filter((item) => item.category === tabs[selectedTab]);
    }
    return (
        <div>
            <PageTitle title={t('reply.provisional.refusal')} details={''} />
            <div className={classes.onlineServiceTitle}>
                <PageTitleBreadcrumb
                    parentTitle={t('online.services.title')}
                    parentLink={`/online-services/${service}`}
                    title={t(service + 's')}
                    details={t(service + '.description')}
                    subTitle={t(service + '.eServices')}
                    subLink={`/online-services/${service}/${category}`}
                    thirdLevelTitle={t('reply.provisional.refusal')}
                />
            </div>
            {globals ? (
                <div className={classes.profileTabContainer}>{service && <ServicesList items={availableItems} navigateTo={navigateTo} />}</div>
            ) : (
                <>
                    <CircularProgress aria-hidden="true" />
                    <Typography variant="srOnly" role="alert">
                        {t('loading.text')}
                    </Typography>
                </>
            )}
            <FieldsMissingDialog open={dialogOpen} onAccept={navigateToProfile} onCancel={cancelMessage} />
        </div>
    );
};

export default ReplyProvisionalRefusalPage;
